import { useState, useEffect, forwardRef, useMemo } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { dropdownProps } from 'src/models/leave';

interface MultiSelectProps {
  title?: string;
  formControlClass?: string;
  placeholder?: string;
  dropdownList: dropdownProps[] | [],
  value: string[] | [],
  onChange: (e: any) => void,
  isSearchDisabled?: boolean;
}

const MultiSelect = forwardRef((props: MultiSelectProps, _ref) => {
  const [list] = useState<dropdownProps[]>(props?.dropdownList);
  const [selectedList, setSelectedList] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>('');

  useEffect(() => {
    if(props?.value){
      setSelectedList(props?.value);
    }
  }, [props?.value]);

  //search list by name
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const filteredList = useMemo(
    () =>
      list.length > 0 &&
      list?.filter((option) => containsText(option?.name, searchText)),
    [list, searchText]
  );

  useEffect(() => {
    const selectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = list.filter(e => e.value.toString() === props?.value[i]);
        selectedName.push(result[0]?.name);
      }
    }
    setSelectedList(selectedName);
  }, [list, props?.value]);

  return (
    <FormControl fullWidth 
      className={props?.formControlClass ? props?.formControlClass : ''}>
      {props?.title &&
        <InputLabel
          style={{
            fontSize: '12px'
          }}
        >
          {props?.title}
        </InputLabel>
      }
      <Select
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        fullWidth
        multiple
        size="small"
        value={props.value}
        renderValue={() => selectedList.join(', ')}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
        placeholder={props?.placeholder ? props?.placeholder : ''}
      >
        {props?.isSearchDisabled &&
        <ListSubheader>
          <TextField
            id="search-dropdown"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>}
        {
          filteredList?.length > 0 &&
          filteredList.map((item, index) => {
            return (
              <MenuItem key={index} 
                value={item?.value}>
                  <Checkbox checked={props?.value.indexOf(item?.value as never) > -1} />
                  <ListItemText primary={item?.name} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default MultiSelect;
